// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/firstparty/v4/payment_method.proto

/* oxlint-disable */

/** The status of the payment method. */
export const ApiPaymentMethodStatus = {
  /** PAYMENT_METHOD_STATUS_UNSPECIFIED - Unspecified method status. */
  PAYMENT_METHOD_STATUS_UNSPECIFIED: "PAYMENT_METHOD_STATUS_UNSPECIFIED",
  /** PAYMENT_METHOD_STATUS_INACTIVE - Method is inactive. */
  PAYMENT_METHOD_STATUS_INACTIVE: "PAYMENT_METHOD_STATUS_INACTIVE",
  /** PAYMENT_METHOD_STATUS_ACTIVE - Method is active. */
  PAYMENT_METHOD_STATUS_ACTIVE: "PAYMENT_METHOD_STATUS_ACTIVE",
  /** PAYMENT_METHOD_STATUS_PENDING_REVIEW - Method is pending review. */
  PAYMENT_METHOD_STATUS_PENDING_REVIEW: "PAYMENT_METHOD_STATUS_PENDING_REVIEW",
  /** PAYMENT_METHOD_STATUS_PENDING_EXTERNAL - Method is pending external processing. */
  PAYMENT_METHOD_STATUS_PENDING_EXTERNAL: "PAYMENT_METHOD_STATUS_PENDING_EXTERNAL",
  /** PAYMENT_METHOD_STATUS_PENDING_ONBOARDING - Method is pending onboarding. */
  PAYMENT_METHOD_STATUS_PENDING_ONBOARDING: "PAYMENT_METHOD_STATUS_PENDING_ONBOARDING",
  /** PAYMENT_METHOD_STATUS_REJECTED - Method was rejected. */
  PAYMENT_METHOD_STATUS_REJECTED: "PAYMENT_METHOD_STATUS_REJECTED",
} as const;

export type ApiPaymentMethodStatus = typeof ApiPaymentMethodStatus[keyof typeof ApiPaymentMethodStatus];

export namespace ApiPaymentMethodStatus {
  export type PAYMENT_METHOD_STATUS_UNSPECIFIED = typeof ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_UNSPECIFIED;
  export type PAYMENT_METHOD_STATUS_INACTIVE = typeof ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_INACTIVE;
  export type PAYMENT_METHOD_STATUS_ACTIVE = typeof ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_ACTIVE;
  export type PAYMENT_METHOD_STATUS_PENDING_REVIEW = typeof ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_REVIEW;
  export type PAYMENT_METHOD_STATUS_PENDING_EXTERNAL =
    typeof ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_EXTERNAL;
  export type PAYMENT_METHOD_STATUS_PENDING_ONBOARDING =
    typeof ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_ONBOARDING;
  export type PAYMENT_METHOD_STATUS_REJECTED = typeof ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_REJECTED;
}

export function apiPaymentMethodStatusFromJSON(object: any): ApiPaymentMethodStatus {
  switch (object) {
    case 0:
    case "PAYMENT_METHOD_STATUS_UNSPECIFIED":
      return ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_UNSPECIFIED;
    case 1:
    case "PAYMENT_METHOD_STATUS_INACTIVE":
      return ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_INACTIVE;
    case 2:
    case "PAYMENT_METHOD_STATUS_ACTIVE":
      return ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_ACTIVE;
    case 3:
    case "PAYMENT_METHOD_STATUS_PENDING_REVIEW":
      return ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_REVIEW;
    case 4:
    case "PAYMENT_METHOD_STATUS_PENDING_EXTERNAL":
      return ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_EXTERNAL;
    case 5:
    case "PAYMENT_METHOD_STATUS_PENDING_ONBOARDING":
      return ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_ONBOARDING;
    case 6:
    case "PAYMENT_METHOD_STATUS_REJECTED":
      return ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_REJECTED;
    default:
      return ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_UNSPECIFIED;
  }
}

export function apiPaymentMethodStatusToJSON(object: ApiPaymentMethodStatus): string {
  switch (object) {
    case ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_UNSPECIFIED:
      return "PAYMENT_METHOD_STATUS_UNSPECIFIED";
    case ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_INACTIVE:
      return "PAYMENT_METHOD_STATUS_INACTIVE";
    case ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_ACTIVE:
      return "PAYMENT_METHOD_STATUS_ACTIVE";
    case ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_REVIEW:
      return "PAYMENT_METHOD_STATUS_PENDING_REVIEW";
    case ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_EXTERNAL:
      return "PAYMENT_METHOD_STATUS_PENDING_EXTERNAL";
    case ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_ONBOARDING:
      return "PAYMENT_METHOD_STATUS_PENDING_ONBOARDING";
    case ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_REJECTED:
      return "PAYMENT_METHOD_STATUS_REJECTED";
    default:
      return "PAYMENT_METHOD_STATUS_UNSPECIFIED";
  }
}

/** Enum for payment methods */
export const ApiPaymentMethod = {
  /** PAYMENT_METHOD_UNSPECIFIED - Default unspecified value for unknown or unrecognized payment method */
  PAYMENT_METHOD_UNSPECIFIED: "PAYMENT_METHOD_UNSPECIFIED",
  /** PAYMENT_METHOD_CREDIT_CARD - Credit card payment method */
  PAYMENT_METHOD_CREDIT_CARD: "PAYMENT_METHOD_CREDIT_CARD",
  /** PAYMENT_METHOD_APPLE_PAY - Apple Pay payment method */
  PAYMENT_METHOD_APPLE_PAY: "PAYMENT_METHOD_APPLE_PAY",
  /** PAYMENT_METHOD_PAYPAL - PayPal payment method */
  PAYMENT_METHOD_PAYPAL: "PAYMENT_METHOD_PAYPAL",
  /** PAYMENT_METHOD_IDEAL - iDEAL payment method */
  PAYMENT_METHOD_IDEAL: "PAYMENT_METHOD_IDEAL",
  /** PAYMENT_METHOD_BANK_TRANSFER - Bank transfer payment method */
  PAYMENT_METHOD_BANK_TRANSFER: "PAYMENT_METHOD_BANK_TRANSFER",
} as const;

export type ApiPaymentMethod = typeof ApiPaymentMethod[keyof typeof ApiPaymentMethod];

export namespace ApiPaymentMethod {
  export type PAYMENT_METHOD_UNSPECIFIED = typeof ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
  export type PAYMENT_METHOD_CREDIT_CARD = typeof ApiPaymentMethod.PAYMENT_METHOD_CREDIT_CARD;
  export type PAYMENT_METHOD_APPLE_PAY = typeof ApiPaymentMethod.PAYMENT_METHOD_APPLE_PAY;
  export type PAYMENT_METHOD_PAYPAL = typeof ApiPaymentMethod.PAYMENT_METHOD_PAYPAL;
  export type PAYMENT_METHOD_IDEAL = typeof ApiPaymentMethod.PAYMENT_METHOD_IDEAL;
  export type PAYMENT_METHOD_BANK_TRANSFER = typeof ApiPaymentMethod.PAYMENT_METHOD_BANK_TRANSFER;
}

export function apiPaymentMethodFromJSON(object: any): ApiPaymentMethod {
  switch (object) {
    case 0:
    case "PAYMENT_METHOD_UNSPECIFIED":
      return ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
    case 1:
    case "PAYMENT_METHOD_CREDIT_CARD":
      return ApiPaymentMethod.PAYMENT_METHOD_CREDIT_CARD;
    case 2:
    case "PAYMENT_METHOD_APPLE_PAY":
      return ApiPaymentMethod.PAYMENT_METHOD_APPLE_PAY;
    case 3:
    case "PAYMENT_METHOD_PAYPAL":
      return ApiPaymentMethod.PAYMENT_METHOD_PAYPAL;
    case 4:
    case "PAYMENT_METHOD_IDEAL":
      return ApiPaymentMethod.PAYMENT_METHOD_IDEAL;
    case 5:
    case "PAYMENT_METHOD_BANK_TRANSFER":
      return ApiPaymentMethod.PAYMENT_METHOD_BANK_TRANSFER;
    default:
      return ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
  }
}

export function apiPaymentMethodToJSON(object: ApiPaymentMethod): string {
  switch (object) {
    case ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED:
      return "PAYMENT_METHOD_UNSPECIFIED";
    case ApiPaymentMethod.PAYMENT_METHOD_CREDIT_CARD:
      return "PAYMENT_METHOD_CREDIT_CARD";
    case ApiPaymentMethod.PAYMENT_METHOD_APPLE_PAY:
      return "PAYMENT_METHOD_APPLE_PAY";
    case ApiPaymentMethod.PAYMENT_METHOD_PAYPAL:
      return "PAYMENT_METHOD_PAYPAL";
    case ApiPaymentMethod.PAYMENT_METHOD_IDEAL:
      return "PAYMENT_METHOD_IDEAL";
    case ApiPaymentMethod.PAYMENT_METHOD_BANK_TRANSFER:
      return "PAYMENT_METHOD_BANK_TRANSFER";
    default:
      return "PAYMENT_METHOD_UNSPECIFIED";
  }
}

/** Message for payment method */
export interface ApiMethod {
  /** Unique identifier for the payment method. */
  readonly id: ApiPaymentMethod;
  /** Whether the payment method is enabled for the provided filters. */
  readonly enabled: boolean;
  /** The activation status of the payment method. */
  readonly status: ApiPaymentMethodStatus;
  /** Whether the payment method is eligible based on the input resource type + is_recurrent. */
  readonly eligible: boolean;
}

export const ApiMethod: MessageFns<ApiMethod> = {
  fromJSON(object: any): ApiMethod {
    return {
      id: isSet(object.id) ? apiPaymentMethodFromJSON(object.id) : ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      status: isSet(object.status)
        ? apiPaymentMethodStatusFromJSON(object.status)
        : ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_UNSPECIFIED,
      eligible: isSet(object.eligible) ? globalThis.Boolean(object.eligible) : false,
    };
  },

  toJSON(message: ApiMethod): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = apiPaymentMethodToJSON(message.id);
    }
    if (message.enabled !== undefined && message.enabled !== null) {
      obj.enabled = message.enabled;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiPaymentMethodStatusToJSON(message.status);
    }
    if (message.eligible !== undefined && message.eligible !== null) {
      obj.eligible = message.eligible;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
